import * as moment from "moment";
import "moment/locale/fr";

const configureLocale = () => {
  moment.locale("fr");
};

export default configureLocale;
